import React, { Component } from 'react';
import { HttpRequestService } from '../services/HttpRequestService';

class CurrencySelect extends Component {

    constructor(props) {
        super(props);
        this.state = { currencies: [] };
        this.getCurrencies = this.getCurrencies.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.http = new HttpRequestService();
    }

    componentDidMount() {
        this.getCurrencies();
    }

    componentWillUnmount() {

    }

    getCurrencies() {
        this.http.get('/api/Orders/GetCurrencies', null).then(data=>{
            this.setState({ currencies: data });
            if(data.length > 0 && this.props.value === 0){
                this.props.onChange(data[0].key);
            }
        });
    }

    handleChange(e) {
        this.props.onChange(e.target.value);
    }

    render() {
        var options = this.state.currencies.map((currency) =>
            <option key={currency.key} value={currency.key}>{currency.value}</option>
        );

        return (
            <select className="form-control" value={this.props.value} onChange={this.handleChange}>
                {this.props.hasAllOption === true &&
                    <option value={"-1"}>-- ALL --</option>
                }
                {options}
            </select>
        );
    }
}
export default CurrencySelect